// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_bd-0";